<template>
  <div class="listbox-delete-wrapper">    
      <div v-show="isHidden">
          <a v-on:click="isHidden = !isHidden" class="listbox-delete">
              <i aria-hidden="true" class="material-icons">remove_circle</i>
          </a>
      </div>
      <div v-if="!isHidden" class="delete-wrapper" v-click-outside="onClickOutside">
          <div class="confirm-delete-wrapper w-full h-full">
            Confirm Delete?
            <button 
              @click="deleteItem" 
              type="submit" 
              class="commitbutton text-red-700"
              :class="{ 'loading': submitting }"
            ><i aria-hidden="true" class="material-icons align-middle text-xl">delete</i></button>
          </div>
          <div v-if="errors.length">
            <p v-for="error in errors"
              class="leading-tight text-red-700 text-xs pb-0 my-3"
            >
              {{ error }}
            </p>
          </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios'
import vClickOutside from 'v-click-outside'

  export default {

        props: {
            value: '',
            route:''
        },

        data() {
          return {
            isHidden: true,
            submitting: false,
            errors: [],
          }
        },
        directives: {
          clickOutside: vClickOutside.directive
        },
        methods: {
          onClickOutside (event) {
              this.isHidden = !this.isHidden
              // console.log('Clicked outside. Event: ', event)
          },
          deleteItem: function (event) {
            if (! this.submitting) {
              this.submitting = true;
              this.errors = [];
              axios.delete(this.route,
              ).then(() => {
                location.reload();
              })
              .catch((errors) => {
                this.submitting = false;
                this.errors = errors.response?.data?.errors?.[this.routeparam] || [];
              })
            };
          }

        },
      };
</script>
